const numberFormat = (number)=>{
	if(number > 10000){
		return parseInt(number/10000)+'万'
	}
	return number;
}


export default {
	numberFormat
}


// WEBPACK FOOTER //
// ./src/utils/index.js